
/**
 * 프로젝트 공개 설정
 */
export type ProjectSaveRequestMetadataVisibility = typeof ProjectSaveRequestMetadataVisibility[keyof typeof ProjectSaveRequestMetadataVisibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectSaveRequestMetadataVisibility = {
  public: 'public',
  private: 'private',
  unlisted: 'unlisted',
} as const;
